import { Component, OnInit, Inject } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, NavigationExtras } from "@angular/router";

import { WebStorageService, SESSION_STORAGE } from "ngx-webstorage-service";
import { AlertComponent } from "ngx-bootstrap/alert/alert.component";

import { InventoryCountFacade } from "../../../common/facade/InventoryCountFacade";
import { InventoryCountTagDet } from "../../../common/model/InventoryCountTagDet";
import { InventoryCountTagDetFacade } from "../../../common/facade/InventoryCountTagDetFacade";
import { InventoryCount } from "../../../common/model/InventoryCount";
import { InventoryCountSummaryDto } from "../../../common/model/dto/InventoryCountSummaryDto";
import { ExcelUtility } from "../../../common/util/ExcelUtility";
import { Permissions } from "../../../common/model/dictionary/Permissions";
import { CatalogDetInfo } from "../../../common/model/dictionary/CatalogDetInfo";
import { InventoryCountSummaryTPVDto } from "../../../common/model/dto/InventoryCountSummaryTPVDto";
import { InventoryCountTag } from "../../../common/model/InventoryCountTag";
import { InventoryCountTagSummaryDto } from "../../../common/model/dto/InventoryCountTagSummaryDto";
import { Strings } from "../../../common/language/strings";
import { res } from "../../../common/language/text/res";
import { title } from "process";

@Component({
  selector: "app-inventory-count-detail",
  templateUrl: "./inventory-count-detail.component.html",
  styleUrls: ["./inventory-count-detail.component.css"],
})
export class InventoryCountDetailComponent implements OnInit {
  titleInventoryReference = res.InventoryReference;
  lblSave = res.Save;
  lblUser = res.User;
  lblProfile = res.Profile;
  lblInventoryType = res.InventoryType;
  lblStore = res.Store;
  lblTags = res.Tags;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;
  lblDownload = res.Download;
  lblSearch = res.Search;
  lblProduct = res.Product;
  lblStyle = res.Style;
  lblVariety = res.Variety;
  lblCountingQuantity = res.CountingQuantity;
  lblDepartment = res.Department;
  lblGender = res.Gender;
  lblBrand = res.Brand;
  lblScanned = res.Scanned;
  lblSize = res.Size;
  lblTitleScannedProductSummary = res.TitleScannedProductSummary;
  lblTitleDiferencesReportStyleVariety = res.TitleDiferencesReportStyleVariety;
  lblTitleScansPerformedByPoduct = res.TitleScansPerformedByProduct;
  lblTitleInventoryFilters = res.TitleInventoryFilters;
  lblQuantumScanned = res.QuantumScanned;
  lblDifferences = res.Differences;
  lblStocksTPV = res.StocksTPV;
  lblSummary = res.Summary;
  lblTag = res.Tag;
  lblQuantity = res.Quantity;
  lblTotalStocksTPV = res.TotalStocksTPV;
  lblTotalScannedQuantum = res.TotalScannedQuantum;
  lblTotalDifferences = res.TotalDifferences;

  isSpanish = true;
  isUSAStore = false;
  language = 0;
  society = 0;

  messagesTable: any = {
    emptyMessage: "",
    totalMessage: "",
  };

  loading = false;
  messageLoader = "";
  // alert
  generalAlerts = [];
  // datos
  code = "";
  codewithTPV = "";
  username = "";
  profile = "";
  type = "";
  inventoryType: number;
  store = "";
  marbetes = "";
  fechaInicio = "";
  fechaFin = "";
  txtCharlyDesk = "";
  txtSAP = "";
  txtDiferencias = "";
  txtCostoDiferencia = "";
  txtCountSAP = 0;
  flagGlobalInventory = true;
  totalStocksTPV = 0;
  totalScannedQuantum = 0;
  totalDifferences = 0;
  public startDate: string;
  public endDate: string;
  public extras: NavigationExtras;
  public path = "inventory/counts/physical";
  _inventoryCount: InventoryCount;
  _organizationId: string;
  _store: number;
  _title: number;

  // table
  rows: InventoryCountTagDet[] = [];
  rowsTPV: InventoryCountTagDet[] = [];
  rowsTPVGlobal: InventoryCountTag[] = [];
  private _filteredData: InventoryCountTagDet[] = [];
  private _filteredDataTPV: InventoryCountTagDet[] = [];
  _id = 0;
  rowSummary: InventoryCountSummaryDto[] = [];
  rowSummaryTPV: InventoryCountSummaryTPVDto[] = [];
  rowSummaryTPVGlobal: InventoryCountTagSummaryDto[] = [];
  lstTMP: InventoryCountSummaryDto[] = [];
  fileUrl;
  fileUrl2;

  // permissions
  permissionsList: any[] = [];
  visibleAdd = false;
  visibleEdit = false;

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private invCountFacade: InventoryCountFacade,
    private activatedRoute: ActivatedRoute,
    private inventoryCountTagDetFacade: InventoryCountTagDetFacade,
    private _excel: ExcelUtility,
    private sanitizer: DomSanitizer,
    public strings: Strings
  ) {}

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.isUSAStore = this.strings.getUSAStore();

    this.messagesTable.emptyMessage = this.strings.GetText(
      res.ThereIsNoInformation
    );
    this.messagesTable.totalMessage = "Total";

    if (!this.isSpanish) {
      this.language = 1;
    }

    if (this.isUSAStore) {
      this.society = 12;
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      this._id = Number(params["id"]);
      this.startDate = params["startDate"];
      this.endDate = params["endDate"];
      this._organizationId = params["orgId"];
      this._store = params['storeId'];
      this._title = params['titleId']
    });

    this.extras = {
      queryParams: {
        startDate: this.startDate,
        endDate: this.endDate,
        orgId: this._organizationId,
        storeId: this._store,
        titleId: this._title
      },
    };

    this._id = Number(this.activatedRoute.snapshot.paramMap.get("id"));

    this.getInventoryCount();
  }

  private getInventoryCount() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    // tslint:disable-next-line: deprecation
    this.invCountFacade.GetInventoryCount(this._id, this.language).subscribe(
      (response) => {
        this._inventoryCount = response.data;
        this._inventoryCount.language = this.language;
        this.code = response.data.code;
        this.codewithTPV = response.data.code;
        this.username = response.data.employeeName;
        this.profile = response.data.catDetJobName;
        this.type = response.data.catDetTypeName;
        this.inventoryType = response.data.catDetType;
        this.store = response.data.storeName;
        this.marbetes = response.data.inventoryCountTagQuantity.toString();
        this.fechaInicio = response.data.startDate;
        this.fechaFin = response.data.endDate;
        this.txtCharlyDesk = response.data.codeServiceDesk;
        this.txtSAP = response.data.codeSAP;
        this.txtDiferencias =
          response.data.difference !== 0
            ? response.data.difference.toString()
            : "";
        this.txtCostoDiferencia =
          response.data.costDifference !== 0
            ? response.data.costDifference.toString()
            : "";
        this.txtCountSAP = response.data.countSAP;
        if (response.data.catDetType === CatalogDetInfo.InvetoryGlobalType) {
          const item = new InventoryCountTagSummaryDto();
          response.data.inventoryCountTags.forEach((tag) => {
            item.countQuantum += tag.countValidation;
          });
          item.countSap = response.data.countSAP;
          item.countTPV = response.data.countTPV;
          item.diferences = response.data.countSAP - item.countQuantum;
          item.diferencesTPV = response.data.countTPV - item.countQuantum;
          this.rowSummaryTPVGlobal.push(item);
          this.rowsTPVGlobal = response.data.inventoryCountTags;
          this.flagGlobalInventory = true;
          this.getInventoryCountTagDet();
        } else {
          this.flagGlobalInventory = false;
          this.getInventoryCountTagDet();
          this.getInventoryCountSummary();
          this.validatePermissions();
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.addAlert(
          "<strong>¡Error!</strong> " +
            this.strings.GetText(res.AlertInventoryDataCouldNotBeObtained),
          "danger"
        );
      }
    );
  }

  private getInventoryCountTagDet() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    // tslint:disable-next-line: deprecation
    this.inventoryCountTagDetFacade.GetAllByInvCountId(this._id).subscribe(
      (response) => {
        this.rows = response.data;
        this.rowsTPV = response.data;
        this.fullRowsTPV();
        this._filteredData = response.data;
        this.downloadText();
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.addAlert(
          "<strong>¡Error!</strong> " +
            this.strings.GetText(res.AlertInventoryDataCouldNotBeObtained),
          "danger"
        );
      }
    );
  }

  private getInventoryCountSummary() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    const tmpList: InventoryCountSummaryDto[] = [];
    // tslint:disable-next-line: deprecation
    this.invCountFacade
      .GetInventoryCountSummary(this._id, this.language)
      .subscribe(
        (response) => {
          this.lstTMP = response.data;
          this.lstTMP.forEach((element) => {
            if (!element.title.endsWith("TPV")) {
              tmpList.push(element);
            }
          });
          this.fullSummaryTPV(response.data);
          this.fullRowSummary(tmpList);
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.addAlert(
            "<strong>¡Error!</strong> " +
              this.strings.GetText(res.AlertInventoryDataCouldNotBeObtained),
            "danger"
          );
        }
      );
  }

  fullRowSummary(tmpList: InventoryCountSummaryDto[]) {
    tmpList.forEach((element) => {
      if (this.rowSummary.find((x) => x.title === element.title) != null) {
        this.rowSummary.find((x) => x.title === element.title).quantity +=
          element.quantity;
        this.rowSummary.find((x) => x.title === element.title).quantityTPV +=
          element.quantityTPV;
      } else {
        this.rowSummary.push(element);
      }
    });
  }

  fullSummaryTPV(summary: InventoryCountSummaryDto[]) {
    let element: InventoryCountSummaryTPVDto;
    let tmpIndex = 0;
    let tmpName = "";
    summary.forEach((item) => {
      if (this.rowSummaryTPV.length === 0) {
        element = new InventoryCountSummaryTPVDto();
        this.rowSummaryTPV.push(element);
      } else if (this.rowSummaryTPV.length > 0) {
        if (
          tmpName === "" &&
          !item.titleType.includes("Brand") &&
          !item.titleType.includes("Scan")
        ) {
          tmpName = item.titleType;
          this.rowSummaryTPV[tmpIndex].gender = item.title;
          this.rowSummaryTPV[tmpIndex].quantityQuantum = item.quantity;
          this.rowSummaryTPV[tmpIndex].section = item.section;
        } else if (item.titleType.includes("Gender")) {
          if (!item.titleType.endsWith("TPVGender")) {
            tmpIndex++;
            if (tmpIndex + 1 > this.rowSummaryTPV.length) {
              element = new InventoryCountSummaryTPVDto();
              element.gender = item.title;
              element.quantityQuantum = item.quantity;
              element.quantityTPV = item.quantityTPV;
              element.section = item.section;
              this.rowSummaryTPV.push(element);
            }
          } else {
            this.rowSummaryTPV[tmpIndex].quantityTPV = item.quantityTPV;
          }
        }
      }
    });
    this.rowSummaryTPV.forEach((element) => {
      this.totalStocksTPV += element.quantityTPV;
      this.totalScannedQuantum += element.quantityQuantum;
    });
    this.totalDifferences = this.totalScannedQuantum - this.totalStocksTPV;
    this.rowSummaryTPV.sort((a, b) => a.section.localeCompare(b.section));
  }

  fullRowsTPV() {
    const tempList: InventoryCountTagDet[] = [];
    this.rowsTPV.forEach((it) => {
      const item = it;
      let counter = 0;
      if (
        tempList.find(
          (x) =>
            x.itemId === item.itemId && x.sizeGroupDetId === item.sizeGroupDetId
        ) == null
      ) {
        this.rowsTPV.forEach((c) => {
          if (
            c.itemId === item.itemId &&
            c.sizeGroupDetId === item.sizeGroupDetId
          ) {
            if (counter > 0) {
              item.count2 = c.count + item.count2;
            } else {
              item.count2 = c.count;
            }
            counter++;
          }
        });
        tempList.push(item);
      }
    });
    this.rowsTPV = tempList;
    this._filteredDataTPV = this.rowsTPV;
    this.downloadTextWithTPV();
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.generalAlerts = [];
    this.generalAlerts.push({
      type: type,
      msg: message,
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent): void {
    this.generalAlerts = this.generalAlerts.filter(
      (alert) => alert !== dismissedAlert
    );
  }

  // filters
  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (
          item[keys[i]] != null &&
          (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)
        ) {
          return true;
        }
      }
    });
  }

  updateFilterWithTPV(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredDataTPV[0]);
    // assign filtered matches to the active datatable
    this.rowsTPV = this._filteredDataTPV.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (
          item[keys[i]] != null &&
          (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)
        ) {
          return true;
        }
      }
    });
  }

  // update los datos del inventario
  updateInventory() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    const inv = new InventoryCount();
    inv.invCountId = this._id;
    inv.difference = Number(this.txtDiferencias);
    inv.costDifference = Number(this.txtCostoDiferencia);
    inv.codeSAP = this.txtSAP;
    inv.codeServiceDesk = this.txtCharlyDesk;
    // tslint:disable-next-line: deprecation
    this.invCountFacade.UpdateInventoryCount(inv).subscribe(
      (response) => {
        this.loading = false;
        this.addAlert(
          "<strong> " +
            this.strings.GetText(res.AlertTheDataHasBeenUpdatedSuccessfully) +
            "</strong>",
          "success"
        );
      },
      (error) => {
        this.loading = false;
        this.addAlert(
          "<strong>¡Error!</strong> " +
            this.strings.GetText(res.AlertInventoryDataCouldNotBeObtained),
          "danger"
        );
      }
    );
  }

  // Save excel
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach((row) => {
        const info = {
          [this.strings.GetText(res.Product)]: row.description,
          EAN: row.code,
          [this.strings.GetText(res.Style) +
          " " +
          this.strings.GetText(res.Variety)]: row.styleVariety,
          [this.strings.GetText(res.Size)]: row.sizeName,
          [this.strings.GetText(res.CountingQuantity)]: row.count,
          [this.strings.GetText(res.Department)]: row.catDetSectionName,
          [this.strings.GetText(res.Gender)]: row.catDetGenderName,
          [this.strings.GetText(res.Brand)]: row.catDetBrandName,
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, this.code);
    } else {
      this.addAlert(
        this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile),
        "danger"
      );
    }
  }

  downloadLayoutWithTPV() {
    if (this.rowsTPV.length > 0) {
      const data: any = [];
      this.rowsTPV.forEach((row) => {
        const info = {
          [this.strings.GetText(res.Detail)]: row.styleVariety,
          [this.strings.GetText(res.Brand)]: row.catDetBrandName,
          [this.strings.GetText(res.Department)]: row.catDetSectionName,
          [this.strings.GetText(res.Gender)]: row.catDetGenderName,
          [this.strings.GetText(res.Size)]: row.sizeName,
          [this.strings.GetText(res.Quantity) + " TPV"]: row.countTPV,
          [this.strings.GetText(res.CountingQuantity)]: row.count2,
          [this.strings.GetText(res.Differences)]: row.count2 - row.countTPV,
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, this.codewithTPV);
    } else {
      this.addAlert(
        this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile),
        "danger"
      );
    }
  }

  // Save txt
  downloadText() {
    if (this.rows.length > 0) {
      let data = "";
      this.rows.forEach((row) => {
        data = data + "3" + row.code + "," + row.count + "\n";
      });
      const blob = new Blob([data], { type: "application/octet-stream" });
      this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        window.URL.createObjectURL(blob)
      );
    } else {
      this.addAlert(
        this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile),
        "danger"
      );
    }
  }

  downloadTextWithTPV() {
    if (this.rowsTPV.length > 0) {
      let data = "";
      this.rowsTPV.forEach((row) => {
        data = data + "3" + row.code + "," + row.count2 + "\n";
      });
      const blob = new Blob([data], { type: "application/octet-stream" });
      this.fileUrl2 = this.sanitizer.bypassSecurityTrustResourceUrl(
        window.URL.createObjectURL(blob)
      );
    } else {
      this.addAlert(
        this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile),
        "danger"
      );
    }
  }

  validatePermissions() {
    this.permissionsList.forEach((element) => {
      // tslint:disable-next-line: triple-equals
      if (
        element.name == Permissions.GeneralAccess ||
        element.name == Permissions.InventarioConteoCreate ||
        Permissions.InventarioFisicoCreate
      ) {
        this.visibleAdd = true;
      }
    });

    this.permissionsList.forEach((element) => {
      // tslint:disable-next-line: triple-equals
      if (
        element.name == Permissions.GeneralAccess ||
        element.name == Permissions.InventarioConteoEdit ||
        Permissions.InventarioFisicoEdit
      ) {
        this.visibleEdit = true;
      }
    });
  }

  createPDF() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Generating) + " PDF";
    var nav: any = window.navigator;

    this.invCountFacade.GetReportPdf(this._inventoryCount).subscribe(
      (result) => {
        if (result.completed) {
          try {
            const filename =
              this.strings.GetText(res.Inventory) + ": " + this.code + ".pdf";
            const blobData = this.convertBase64ToBlobData(result.data);

            if (nav && nav.msSaveOrOpenBlob) {
              //IE
              nav.msSaveOrOpenBlob(blobData, filename);
            } else {
              // chrome
              const blob = new Blob([blobData], {
                type: "application/octet-stream",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = filename;
              link.click();
            }
          } catch {
            this.addAlert(
              this.strings.GetText(res.AlertOperationCouldNotBeCompleted),
              "danger"
            );
          }
        } else {
          this.addAlert(result.message, "danger");
        }

        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.addAlert(error, "danger");
      }
    );
  }

  convertBase64ToBlobData(
    base64Data: string,
    contentType: string = "image/png",
    sliceSize = 512
  ) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
